import React from 'react';
import {
  ModalOverlay,
  ModalContainer,
  CloseButton,
  ModalTitle,
  ModalDescription,
  ActionButton
} from './style';

const SubscriptionPopup = ({ 
  isOpen, 
  onClose, 
  title, 
  description, 
  buttonText = "Start using JeddAIs",
  onButtonClick 
}) => {
  if (!isOpen) return null;

  const handleButtonClick = () => {
    if (onButtonClick) {
      onButtonClick();
    }
    onClose();
  };

  return (
    <ModalOverlay onClick={onClose}>
      <ModalContainer onClick={(e) => e.stopPropagation()}>
        <CloseButton onClick={onClose}>×</CloseButton>
        
        <ModalTitle>{title}</ModalTitle>
        <ModalDescription>{description}</ModalDescription>
        
        <ActionButton onClick={handleButtonClick}>
          {buttonText}
        </ActionButton>
      </ModalContainer>
    </ModalOverlay>
  );
};

export default SubscriptionPopup;